module.exports = __webpack_public_path__ + "img/rascrut-10.835b8b0d.webp";